import React from 'react';
import Link from 'next/link';
import { useFormContext } from 'react-hook-form';

import { Icon, IconType, SVG } from 'components/tokens/Icon';
import { Colors } from 'enums/Colors';

import styles from './InputRadio.module.scss';

export interface InputRadioProps {
  name: string;
  icon?: SVG;
  iconColor?: Colors;
  iconSize?: number;
  iconType?: IconType;
  title: string;
  subtitle?: string;
  value: string;
  disabled?: boolean;
  link?: string;
  darkMode?: boolean;
  registerOptions?: any;
  size?: 'small' | 'medium';
}

const sizeClasses = {
  radio: {
    small: styles.radioSmall,
  },
  text: {
    small: styles.textSmall,
  },
};

export const InputRadio: React.FC<InputRadioProps> = ({
  name,
  icon,
  iconColor,
  iconSize,
  iconType,
  title,
  subtitle,
  value,
  disabled,
  link,
  darkMode,
  registerOptions = {},
  size = 'medium',
}) => {
  const { register, watch } = useFormContext();

  const checked = watch(name);

  return (
    <label
      className={`${styles.radio} ${checked === value ? styles.checked : ''} ${
        disabled ? styles.disabled : ''
      } ${!icon ? styles.noIcon : ''} ${icon && !subtitle ? styles.WithIconNoSubtitle : ''} ${
        darkMode ? styles.darkMode : ''
      } ${sizeClasses.radio[size]}`}
    >
      {icon && (
        <div className={styles.icon}>
          <Icon
            icon={icon}
            color={disabled ? Colors.DarkBlue100 : iconColor}
            size={iconSize}
            type={iconType}
          />
        </div>
      )}
      <div className={`${styles.text} ${sizeClasses.text[size]}`}>
        <span className={styles.title}>{title}</span>
        {subtitle && (
          <span className={styles.subtitle}>
            {subtitle}
            {link && (
              <>
                Genom att gå vidare accepterar jag Zavers{' '}
                <Link href={link}>
                  <a target="_blank" className={styles.termlink}>
                    användarvillkor
                  </a>
                </Link>{' '}
                för betalningar.
              </>
            )}
          </span>
        )}
      </div>
      <input
        {...register(name, registerOptions)}
        type="radio"
        id={name}
        name={name}
        value={value}
        disabled={disabled}
      />
    </label>
  );
};
